import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3';
import env from './env';
import reportErrorToSlack from './reportErrorToSlack';

// Initialize R2 client
const r2Client = new S3Client({
  region: 'auto', // R2 uses 'auto' for region
  endpoint: env('POS_R2_ENDPOINT'), // e.g., https://<account-id>.r2.cloudflarestorage.com
  credentials: {
    accessKeyId: env('POS_R2_ACCESS_KEY_ID'),
    secretAccessKey: env('POS_R2_SECRET_ACCESS_KEY'),
  },
});

const uploadR2File = async (
  file: Blob | File | ArrayBuffer | Uint8Array,
  fileKey: string,
  fileType: string,
  level = 'public',
): Promise<string | undefined> => {
  try {
    // Convert file to Uint8Array for uploading
    let fileData: Uint8Array;

    if (file instanceof Blob || file instanceof File) {
      const arrayBuffer = await file.arrayBuffer();
      fileData = new Uint8Array(arrayBuffer);
    } else if (file instanceof ArrayBuffer) {
      fileData = new Uint8Array(file);
    } else if (file instanceof Uint8Array) {
      fileData = file;
    } else {
      throw new Error('Unsupported file type');
    }

    const command = new PutObjectCommand({
      Bucket: env('POS_R2_BUCKET_NAME'),
      Key: `${level}/${fileKey}`,
      Body: fileData,
      ContentType: fileType,
    });

    await r2Client.send(command);

    // Return the public URL
    // Use custom domain if you have one, otherwise R2 public URL
    const publicUrl = env('POS_R2_PUBLIC_URL'); // e.g., https://cdn.yourdomain.com or https://pub-xxx.r2.dev/bucket-name
    return `${publicUrl}/${level}/${fileKey}`;
  } catch (error: any) {
    console.error('Error uploading file to R2:', error);
    // reportErrorToSlack(
    //   error,
    //   '500',
    //   'User tried uploading an image. Error in *uploadR2File.ts* Component',
    // );

    return undefined;
  }
};

export default uploadR2File;
